import React, { Component } from 'react';

import {
    Link
} from "react-router-dom";
import { _logOut, _clearAllInterval, _getLoginStatus, _getUserLab } from './Constants';
import { _updateNotificationToken } from '../api/Common';
import withNavigateHook from './withNavigateHook';
let $ = window.$;
class LabsHeader extends Component {


    /**
     * 
     * @param {*} props 
     */
    constructor(props) {
        super(props);
        this.action = window.location.pathname.split("/").pop();
        this.state = {
            user: {},
            user_doctor: {}
        }

    }

    /**
    * 
    */
    componentDidMount = async () => {
        let res = await _getLoginStatus();

        if (res['status']) {
            await this.setState({
                user: res.data
            });
        }

        let res1 = await _getUserLab();
        //console.log(res1);
        if (res1['status']) {
            await this.setState({
                user_doctor: res1.data
            });
        }

        await _clearAllInterval();
    }


    /**
     * 
     * @param {*} param 
     */
    _handleLogout = async (e) => {
        e.preventDefault();
        await _updateNotificationToken('', this.state.user.id, 'Doctor', 'logout')
        let res = await _logOut('Doctor');
        this.props.navigation(res);
    }

    /**
       * 
       * @param {*} e 
       */
    _goBack = (e) => {
        e.preventDefault();
        this.props.navigation(-1)
    }


    /**
     * 
     */
    _closeSideNav = () => {
        $('.sidenav').sidenav('close')
    }


    render() {

        return (

            <React.Fragment>
                <header>
                    {
                        this._closeSideNav()
                    }

                    <div className="oparchee-bg1">

                        <div className="container">

                            <div className="row">

                                <div className="col s8">

                                    <div className="loginTxt left-align">
                                        {
                                            this.action != "labs-dashboard" && this.action != "doctors-history" ?
                                                <React.Fragment>
                                                    <Link to="/" onClick={(e) => { this._goBack(e) }}> <i className="material-icons">arrow_back</i>  </Link>
                                                    {/* {this.action.replaceAll('-', ' ').replaceAll('doctors', '').replaceAll('doctor', '').toUpperCase()} */}
                                                </React.Fragment>
                                                :
                                                <Link to="/labs-dashboard" > <i className="material-icons" title="Home">home</i></Link>

                                        }
                                        {this.state.user_doctor != null && typeof this.state.user_doctor.first_name != 'undefined' && this.state.user_doctor.first_name != null ? ' (Dr. ' + this.state.user_doctor.first_name + ' ' + this.state.user_doctor.last_name + ')' : ''}


                                    </div>

                                </div>

                                <div className="col s4">

                                    <div className="skipTxt right-align">

                                        {/* O-Parchee */}
                                        <Link to="/" onClick={(e) => { this._handleLogout(e) }} title="Logout">
                                        <i className="material-icons">logout</i>
                                        </Link>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </header>
                {/* <DoctorsSideMenu user={this.state.user} /> */}
            </React.Fragment>
        );
    }
}

export default withNavigateHook(LabsHeader);
